// FORMS4.love submission helper
// Sends form submissions to https://api.forms4.love

const FORMS4_ENDPOINT = "https://api.forms4.love/v1.0/submit/siozjaqf";
const FORMS4_SENDER_HASH = "qag46cprhmierwxybepjjxdknljgqhix";

export type Forms4FieldType =
  | "email"
  | "phone"
  | "name"
  | "first_name"
  | "last_name"
  | "company"
  | "message"
  | "other";

export type Forms4Field = {
  name: string;
  value: string;
  type: Forms4FieldType | string;
};

async function sha256Hex(input: string): Promise<string> {
  const buf = new TextEncoder().encode(input);
  const digest = await crypto.subtle.digest("SHA-256", buf);
  return Array.from(new Uint8Array(digest))
    .map((b) => b.toString(16).padStart(2, "0"))
    .join("");
}

export type Forms4Response =
  | { status: "ok" }
  | { status: "invalid_hash" | "duplicate_submission" | "not_found" | string };

export async function submitToForms4Love(
  fields: Forms4Field[],
  uuid: string = crypto.randomUUID()
): Promise<Forms4Response> {
  const hash = await sha256Hex(uuid + FORMS4_SENDER_HASH);
  const res = await fetch(FORMS4_ENDPOINT, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ uuid, hash, form_data: fields }),
  });
  if (!res.ok) {
    throw new Error(`FORMS4.love HTTP ${res.status}`);
  }
  return (await res.json()) as Forms4Response;
}
